<template>
  <a-checkbox-group
    v-model:value="checkValue"
    @change="handleChange"
    :disabled="disabled"
    style="width: 100%"
  >
    <a-row v-for="(item, index) in data.optionsList" :key="index" style="line-height: 32px">
      <a-checkbox :value="item.id ? item.id : item.optionContent">
        {{ item.optionContent }}
      </a-checkbox>
      <a-input
        v-model:value="otherValue"
        v-if="item.othersFlag === '1' && otherInputValue"
        :placeholder="data.remind"
        @blur="handleChange"
        :maxlength="500"
        show-count
      />
    </a-row>
  </a-checkbox-group>
</template>
<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'

const props = defineProps({
  data: {
    required: true,
    type: Object,
    default: {}
  },
  value: {
    required: true,
    type: Array,
    default: []
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  }
})

const otherInputValue = computed(() => {
  return props.data.optionsList.some(item => {
    if (item.id) {
      return checkValue.value.includes(item.id) && item.othersFlag === '1'
    } else {
      return checkValue.value.includes(item.optionContent) && item.othersFlag === '1'
    }
  })
})

const emit = defineEmits(['update:value', 'change'])
const checkValue = ref(props.value)

const otherValue = ref('')

// 暂定入参
const handleChange = () => {
  console.log('changge', checkValue.value)
  let arr = props.data.optionsList
    .filter(item => checkValue.value.includes(item.id ? item.id : item.optionContent))
    .map(i => ({
      optionId: i.id || i.optionContent,
      otherContent: i.othersFlag === '1' ? otherValue.value : '',
      othersFlag: i.othersFlag === '1' ? '1' : undefined
    }))
  emit('change', arr)
}

onMounted(async () => {
  if (props.data.fieldValue) {
    checkValue.value = props.data.fieldValue.map(item => item.optionId)
    otherValue.value =
      props.data.fieldValue.find(item => item.otherContent)?.otherContent || undefined
  }
})
</script>
